import React, { useState } from "react";
import { Routes as Router, Route } from "react-router-dom";
import LoginPage from "./pages/Login/Login";
import DashboardPage from "./pages/Dashboard/Dashboard";
import SalePage from "./pages/Sale/Sale";
import SaleDetailPage from "./pages/Sale/SaleDetail";
import SaleReturnListPage from "./pages/Sale/ReturnList";
import SaleReturnPage from "./pages/Sale/Return";
import CreateOrderPage from "./pages/Sale/CreateOrder";
import CustomerPage from "./pages/Customer/Customer";
import CustomerDetailPage from "./pages/Customer/CustomerDetail";
import AdminPage from "./pages/Admin/Admin";
import AdminDetailPage from "./pages/Admin/AdminDetail";
import InventoryPage from "./pages/Inventory/Inventory";
import InventoryDetailPage from "./pages/Inventory/InventoryDetail";
import SaleReportPage from "./pages/SaleReport/SaleReport";
import ShippingChargePage from "./pages/ShippingCharge/ShippingCharge";
import CustomEnquiryPage from "./pages/CustomEnquiry/CustomEnquiry";
import SettingPage from "./pages/Setting/Setting";
import BrandPage from "./pages/Setting/Brand";
import BannerPage from "./pages/Banner/Banner";
import CustomerEnquiryPage from "./pages/CustomerEnquiry/CustomerEnquiry";
import ColorPage from "./pages/Color/Color";
import MaterialPage from "./pages/Material/Material";
import ApparelPage from "./pages/Apparel/Apparel";
import DecorationPage from "./pages/Decoration/Decoration";
import DecorativePage from "./pages/Decorative/Decorative";
import EditCartPage from "./pages/EditCart/EditCart";
import RazerLogPage from "./pages/RazerLog/RazerLog";
import Log from "./pages/Log/Log";
import Log2 from "./pages/Log2/Log2";
import ChangePssword from "./pages/ChangePassword/ChangePssword";

import SliderPage from "./pages/Slider/Slider";
import SliderDetailPage from "./pages/Slider/SliderDetail";
import GroupReturn from "./pages/GroupReturn/GroupReturn";

export default function Routes() {
  return (
    <Router>
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/" element={<LoginPage />} />
      <Route path="/sale" element={<SalePage />} />
      <Route path="/saledetail/:sales_order_id" element={<SaleDetailPage />} />
      <Route
        path="/salereturnlist/:sales_order_id"
        element={<SaleReturnListPage />}
      />
      <Route
        path="/salereturn/:sales_order_id/:sales_order_report_id"
        element={<SaleReturnPage />}
      />
      <Route path="/customer" element={<CustomerPage />} />
      <Route
        path="/customerdetail/:customer_id"
        element={<CustomerDetailPage />}
      />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admindetail/:admin_id" element={<AdminDetailPage />} />
      <Route path="/inventory" element={<InventoryPage />} />
      <Route
        path="/inventorydetail/:item_id"
        element={<InventoryDetailPage />}
      />
      <Route path="/createorder" element={<CreateOrderPage />} />
      <Route path="/salereport" element={<SaleReportPage />} />
      <Route path="/shipping" element={<ShippingChargePage />} />
      <Route path="/custommadeenquiry" element={<CustomEnquiryPage />} />
      <Route path="/setting" element={<SettingPage />} />
      <Route path="/brand" element={<BrandPage />} />
      <Route path="/banner" element={<BannerPage />} />
      <Route path="/customerenquiry" element={<CustomerEnquiryPage />} />
      <Route path="/color" element={<ColorPage />} />
      <Route path="/razerlog" element={<RazerLogPage />} />
      <Route path="/material" element={<MaterialPage />} />
      <Route path="/apparel" element={<ApparelPage />} />
      <Route path="/decoration" element={<DecorationPage />} />
      <Route path="/decorative" element={<DecorativePage />} />
      <Route path="/editcart" element={<EditCartPage />} />
      <Route path="/salesyncstatus" element={<Log />} />
      <Route path="/returnsyncstatus" element={<Log2 />} />
      <Route path="/changepassword" element={<ChangePssword />} />
      <Route path="/slider" element={<SliderPage />} />
      <Route path="/sliderdetail/:product_title_id" element={<SliderDetailPage />} />
      <Route path="/groupreturn" element={<GroupReturn />} />
    </Router>
  );
}
